import { render, staticRenderFns } from "./IxCollapsePanel.vue?vue&type=template&id=76cf5c68&scoped=true&"
import script from "./IxCollapsePanel.vue?vue&type=script&lang=js&"
export * from "./IxCollapsePanel.vue?vue&type=script&lang=js&"
import style0 from "./IxCollapsePanel.vue?vue&type=style&index=0&id=76cf5c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cf5c68",
  null
  
)

export default component.exports